import useWizardFormCtx from '../../../ctx-provider/useWizardFormCtx';
import CheckboxField from "../../../../../cmp/input/CheckboxField";
import FormBo from '../../FormBo';
import { useState } from 'react';
import GtmFormularfeldId from '../../../../../../gtm/types/GtmFormularfeldId';

export const exportOptInTelefon = (bo: FormBo) => bo.optInTelefon;

const OptInTelefon: React.FC = () => {
    const { wizardFormBo, fireWizardFormBo } = useWizardFormCtx();
    const [optInTelefon, setOptInTelefon] = useState(wizardFormBo.antrag.optInTelefon);

    // Formulardaten werden aktualisiert
    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.checked
        setOptInTelefon(value);

        wizardFormBo.antrag.optInTelefon = value;
        fireWizardFormBo(wizardFormBo);
    }

    return (
        <CheckboxField id="optInTelefon" idGtm={GtmFormularfeldId.optInTelefon} label="per Telefon"
            value={optInTelefon}
            onChange={handleOnChange} />
    );
}
export default OptInTelefon;